import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { InputField, IntegerField } from '../../form/field';
import { HorizontalLayout } from '../../form/layout';
import OwnerField from '../field/Owner';

const Dividends = ({ name, ripFromRecommendation }) => (
    <Fragment>
        <HorizontalLayout>
            <IntegerField name={`${name}.income`} title="Montant des dividendes" required />
            <InputField name={`${name}.recurring`} title="Récurrent" type="checkbox" />
            <OwnerField name={`${name}.beneficiary`} title="Bénéficiaire(s)" ripFromRecommendation={ripFromRecommendation} single required />
        </HorizontalLayout>
        <div className="alert alert-warning no-margin-bottom margin-top-10">
            <p>
                Depuis le 01/01/2026, les dividendes sont soumis au PFU de 31,4 % avec acompte &agrave; la source et ne
                sont plus int&eacute;gr&eacute;s dans le calcul de l&apos;IR sauf option pour l&apos;int&eacute;gration
                &agrave; l&apos;imp&ocirc;t sur le revenu. Ce prélèvement constitue un acompte d&apos;impôt sur le revenu. Le montant n&apos;apparait pas sur cet audit afin d&apos;&eacute;viter une double imposition, en l&apos;absence d&apos;option au barème progressif.
            </p>
        </div>
    </Fragment>
);

Dividends.propTypes = {
    name: PropTypes.string.isRequired,
    ripFromRecommendation: PropTypes.shape({}),
};

export default Dividends;
